module.exports = __webpack_public_path__ + "static/media/drawing02.8978f004.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/drawing02.jpg
// module id = 202
// module chunks = 0